export default __webpack_public_path__ + "static/media/exclamation-mark.50d03027.png";